import { useCallback } from "react"

export const useFindObjectRelationProperty = () => {

    return useCallback((data: Record<string, any>): string | undefined => {
        return Object.keys(data).find((key) => /(entrId|derId|docrId|extrId)$/.test(key))
    }, [])
}
